export default class WorkflowPolicy {
    static browse(user) {
        return user.hasPermissionTo('browse:workflows');
    }

    /* eslint-disable-next-line no-unused-vars */
    static read(user, workflow) {
        return user.hasPermissionTo('read:workflows');
    }

    /* eslint-disable-next-line no-unused-vars */
    static edit(user, workflow) {
        return user.hasPermissionTo('edit:workflows');
    }

    static add(user) {
        return user.hasPermissionTo('add:workflows');
    }

    static destroy(user, workflow) {
        return workflow.publications_count === 0
            && user.hasPermissionTo('delete:workflows');
    }
}
